import config from '@/config/defaultSettings';
import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';
import { setupBeforeEach, setupAfterEach } from './routerGuard'
import {generateAsyncRoutes1} from './generateAsyncRoutes'
import routes from './commonRoutes'
import { PERMISSION} from '@/store/mutation-types'
import ls from '@/utils/Storage'
const router = createRouter({
  history: createWebHistory(),
  routes: routes as unknown as RouteRecordRaw[],
});

// 路由守卫,鉴权
setupBeforeEach(router)

setupAfterEach(router)

generateAsyncRoutes1(router)

export default router;
